<template>
  <div>
    <div
      :id="field.temp_prop.paper_size==0?'inch3-thermal-print-page':'inch4-thermal-print-page'"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.13);"
    >
      <div
        class="print-template"
        :style="{'background':field.temp_prop.bg_color.show==1?field.temp_prop.bg_color.value.hex:'#fff'}"
      >
        <!--Header Block -->
        <div
          class="invoice-header-block"
          :style="{'height':field.temp_prop.margin_top+'in'}"
          style="background:#fff"
        ></div>
        <!-- Body -->
        <div
          class="invoice-content-layout"
          :style="{'padding-right':field.temp_prop.margin_right+'in','padding-left':field.temp_prop.margin_left+'in'}"
        >
          <div style="position:relative;">
            <span
              v-show="showprintlabel && printlabel != ''"
              style="position:absolute;right:0;padding:2px 4px;border:2px solid #929292;color:#000;font-size:9pt"
            >{{ printlabel }}</span>

            <!-- Organisation Logo -->
            <div v-if="field.header_prop.show_logo" class="text-center" style="display:block">
              <img
                v-if="field.header_prop.show_logo && org_details.org_logo != null && org_details.org_logo  != ''"
                v-bind:src="imageSrc"
                :style="{'width':field.header_prop.logo_width+'px','height':field.header_prop.logo_height+'px'}"
                style="max-width:240px;max-height:146.44px;"
              />
            </div>
          </div>
          <br v-if="(showprintlabel && printlabel != '') || field.header_prop.show_logo" />
          <!-- Organisation details -->
          <div class="inch3-details-view text-center" style="word-break:break-word">
            <!-- Organisation Name -->
            <h5
              v-if="field.header_prop.show_org_name"
              style="display:block;margin-bottom:3px;margin-top:5px"
              :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
            >{{ org_details.comp_name }}</h5>
            <!-- Organisation address -->
            <div class="thermal-custom-invoice-address">
              <p
                :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                v-if="field.header_prop.show_org_addr"
              >
                <span>{{org_details.addr_line_1 }}</span>
                <span style="padding-left:3px">{{ org_details.addr_line_2 }}</span>
                <span
                  style="padding-left:3px"
                >{{ org_details.org_city }} {{ getDetails($AppDetails.state_details,org_details.org_state,'state_name') }}</span>
                <span style="padding-left:3px">
                  {{ getDetails($AppDetails.country_details,org_details.org_country,'country_name') }}
                  {{ org_details.org_pincode }}
                </span>
              </p>

              <p
                v-if="org_details.gst_type != 3 && org_details.gst_no != ''"
                style="margin-bottom:0px;"
              >
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >GSTIN :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{ org_details.gst_no }}</span>
              </p>
              <p
                v-if="field.header_prop.phone && org_details.phone_no"
                style="word-break: break-word !important;"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.phone}} :</span>

                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{ org_details.phone_no }}</span>
              </p>
              <!-- <p class="mb-0">
                <span
                  href="mailto:#"
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >Mail:</span>

                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{ org_details.org_mail }}</span>
              </p>-->
              <p
                v-if="field.header_prop.doc_place_supply.show"
                style="word-break: break-word !important;"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.doc_place_supply.label}} :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{ $AppDetails.state_details[list.header_details.place_of_supply].state_name }}({{ $AppDetails.state_details[list.header_details.place_of_supply].state_id }})</span>
              </p>

              <!-- <p>Mail: admin@shanki.com</p> -->
              <p
                v-if="field.header_prop.doc_sales_person.show"
                style="margin-bottom:5px !important;word-break: break-word !important;"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.doc_sales_person.label}}:</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{ list.header_details.sales_person_name }}</span>
              </p>
            </div>

            <!-- Document title -->
            <div
              v-if="field.header_prop.show_doc_title"
              class="document-title"
              style="display:block"
            >
              <h6 style="margin-bottom:5px !important;">{{field.header_prop.doc_title}}</h6>
            </div>
            <!-- Invoice details -->
            <div
              class="thermal-invoice-details"
              :style="{'border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 '}"
            >
              <p
                style="margin-bottom:0px !important;display:block;word-break: break-word !important;"
                v-if="field.header_prop.num_field.show"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.num_field.label}} :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  style="font-weight:700 !important;"
                >{{list.header_details.crdt_no}}</span>
              </p>
              <p
                style="margin-bottom:0px !important;display:block;word-break: break-word !important;"
                v-if="field.header_prop.doc_date.show"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.doc_date.label}} :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{getDateFormat(list.header_details.crdt_date)}}</span>
              </p>
              <p
                style="margin-bottom:5px !important;display:block;word-break: break-word !important;"
                v-if="field.header_prop.cus_label.show"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.cus_label.label}} :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{ list.header_details.cus_name }}</span>
              </p>
              <p
                style="margin-bottom:5px !important;display:block;word-break: break-word !important;"
                v-if="field.header_prop.cus_ph_label.show"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.cus_ph_label.label}} :</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{ list.header_details.cus_ph_no_1 }}</span>
              </p>
            </div>
          </div>

          <!-- Organisation details -->
          <div class="inch4-details-view">
            <!-- Organisation Name -->
            <h5
              v-if="field.header_prop.show_org_name"
              style="display:block;margin-bottom:3px;margin-top:5px;"
              class="text-center"
              :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
            >{{ org_details.comp_name }}</h5>
            <!-- Organisation address -->
            <div class="thermal-custom-invoice-address text-center" style="display:flow-root">
              <p
                v-if="field.header_prop.show_org_addr"
                :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
              >
                <span>{{org_details.addr_line_1 }}</span>
                <span style="padding-left:3px">{{ org_details.addr_line_2 }}</span>
                <span
                  style="padding-left:3px"
                >{{ org_details.org_city }} {{ getDetails($AppDetails.state_details,org_details.org_state,'state_name') }}</span>
                <span style="padding-left:3px">
                  {{ getDetails($AppDetails.country_details,org_details.org_country,'country_name') }}
                  {{ org_details.org_pincode }}
                </span>
              </p>
              <div class="float-left" style="margin-top:5px !important">
                <p
                  class="text-left"
                  v-if="field.header_prop.doc_place_supply.show"
                  style="word-break: break-word !important;"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.doc_place_supply.label}} :</span>

                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{ $AppDetails.state_details[list.header_details.place_of_supply].state_name }}({{ $AppDetails.state_details[list.header_details.place_of_supply].state_id }})</span>
                </p>

                <p
                  class="text-left"
                  v-if="field.header_prop.doc_sales_person.show"
                  style="margin-bottom:5px !important;word-break: break-word !important;"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.doc_sales_person.label}} :</span>

                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{ list.header_details.sales_person_name }}</span>
                </p>
              </div>
              <div class="float-right" style="margin-top:5px !important">
                <p class="text-right">
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >GSTIN :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{ org_details.gst_no }}</span>
                </p>

                <p
                  class="text-right"
                  style="margin-bottom:5px !important;word-break: break-word !important;"
                  v-if="field.header_prop.phone && org_details.phone_no"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.phone}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{ org_details.phone_no }}</span>
                </p>
                <!-- <p class="text-right" style="margin-bottom:5px !important;">
                  <span
                    href="mailto:#"
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >Mail :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{ org_details.org_mail }}</span>
                </p>-->
              </div>
            </div>

            <!-- Document title -->
            <div
              class="document-title text-center"
              v-if="field.header_prop.show_doc_title"
              style="display:flow-root"
            >
              <h6
                style="margin-bottom:5px !important;word-break: break-word !important;"
              >{{field.header_prop.doc_title}}</h6>
            </div>
            <!-- Invoice details -->
            <div
              class="thermal-invoice-details"
              :style="{'border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 '}"
            >
              <p
                style="margin-bottom:0px !important;display:block;word-break: break-word !important;"
                class="text-center"
                v-if="field.header_prop.num_field.show"
              >
                <span
                  :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                >{{field.header_prop.num_field.label}}</span>
                <span
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  style="font-weight:700 !important;"
                >{{list.header_details.crdt_no}}</span>
              </p>

              <p
                style="margin-bottom:5px !important;margin-top:5px !important;display: flow-root;word-break: break-word !important;"
              >
                <span class="text-right float-right" v-if="field.header_prop.doc_date.show">
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.doc_date.label}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{getDateFormat(list.header_details.crdt_date)}}</span>
                </span>
                <span class="text-left" v-if="field.header_prop.cus_label.show">
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.cus_label.label}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{ list.header_details.cus_name }}</span>
                </span>
                <span
                  class="text-left"
                  style="display:block"
                  v-if="field.header_prop.cus_ph_label.show"
                >
                  <span
                    :style="{'color':field.temp_prop.label_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{field.header_prop.cus_ph_label.label}} :</span>
                  <span
                    :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  >{{ list.header_details.cus_ph_no_1 }}</span>
                </span>
              </p>
            </div>
          </div>
          <table
            class="custom-invoice-details-table"
            style="width:100%;border-collapse: collapse !important;"
            :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
          >
            <tbody>
              <tr
                v-for="(custom_field) in crdt_settings_details.custom_field"
                v-if="custom_field.print_show == 1 && custom_field.permissions != 'hide' && custom_field.status == 1 && list.header_details[custom_field.field_name]"
                :key="custom_field.index"
              >
                <td
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000','font-size':field.temp_prop.font_size+'pt'}"
                  style="word-break:break-word;width:50%"
                  class="text-left semi-bold left-label-left"
                >{{custom_field.label_name}}</td>
                <td
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  class="text-left left-label-right word-break"
                  v-if="custom_field.datatype == 'select'"
                  style="word-break:break-word !important"
                >: {{ getJsonPresentValue(custom_field.options,'value',list.header_details[custom_field.field_name],'label') }}</td>
                <td
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  class="text-left left-label-right word-break"
                  v-else-if="custom_field.datatype == 'date'"
                  style="word-break:break-word !important"
                >: {{ getDateFormat(list.header_details[custom_field.field_name]) }}</td>
                <td
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  class="text-left left-label-right word-break"
                  v-else-if="custom_field.datatype == 'amount'"
                  style="word-break:break-word !important"
                >: {{ orgCurrencySymbol+' ' +list.header_details[custom_field.field_name] }}</td>
                <td
                  :style="{'color':field.temp_prop.font_color.hex,'font-size':field.temp_prop.font_size+'pt'}"
                  class="text-left left-label-right word-break"
                  style="word-break:break-word !important"
                  v-else
                >: {{ list.header_details[custom_field.field_name] }}</td>
              </tr>
            </tbody>
          </table>
          <!-- Invoice item table -->
          <div
            class="invoice-item-table"
            :style="{'border-top':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 '}"
          >
            <table style="border-collapse: collapse !important;">
              <thead>
                <th
                  v-if="field.item_prop.label.item_no.show"
                  :style="{'width':field.item_prop.label.item_no.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-left"
                >{{field.item_prop.label.item_no.label}}</th>
                <th
                  v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                  :style="{'width':(field.item_prop.label.item.show?field.item_prop.label.item.width:field.item_prop.label.desc.width)+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-left"
                >
                  <template
                    v-if="field.item_prop.label.item.show"
                  >{{field.item_prop.label.item.label+(field.item_prop.label.desc.show?field.item_prop.label.desc.label?(' & '+field.item_prop.label.desc.label):'& Description':'')}}</template>
                  <template v-else>{{field.item_prop.label.desc.label}}</template>
                </th>
                <th
                  :style="{'width':field.item_prop.label.hsn.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-left"
                >{{field.item_prop.label.hsn.label}}</th>
                <th
                  v-if="field.item_prop.label.qty.show"
                  :style="{'width':field.item_prop.label.qty.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-right"
                >{{field.item_prop.label.qty.label}}</th>
                <th
                  v-if="field.item_prop.label.rate.show"
                  :style="{'width':field.item_prop.label.rate.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-right"
                >{{field.item_prop.label.rate.label}}</th>
                <th
                  v-if="field.item_prop.label.discount.show"
                  :style="{'width':field.item_prop.label.discount.width+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-right"
                >{{field.item_prop.label.discount.label}}</th>
                <!-- <th
                  v-if="field.item_prop.label.tax_amt.show || field.item_prop.label.tax.show"
                  :style="{'width':(field.item_prop.label.tax_amt.width) +'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex }"
                  style="display:table-cell;word-break: break-word !important"
                  class="text-right"
                >{{(field.item_prop.label.tax.show?field.item_prop.label.tax.label:field.item_prop.label.tax_amt.label)}}</th>-->
                <th
                  v-for="(tax_split,tax_index) in list.tax_split"
                  :key="tax_index"
                  :style="{'width':(field.item_prop.label.tax.show?field.item_prop.label.tax.width:field.item_prop.label.tax_amt.width)+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex}"
                  v-if="(field.item_prop.label.tax.show||field.item_prop.label.tax_amt.show) && org_details.gst_type == 1"
                  class="text-right"
                >{{tax_split.tax_name}}</th>

                <th
                  v-if="field.item_prop.label.amt.show"
                  :style="{'width':(field.item_prop.label.tax.show?field.item_prop.label.tax.width:field.item_prop.label.tax_amt.width)+'%','border-bottom':field.item_prop.layout.table_border.show == 1? '1px dashed '+ field.item_prop.layout.table_border.value.hex  :'0 ','font-size':field.item_prop.layout.header_font_size +'pt !important','background-color':field.item_prop.layout.bg_color.show == 1?field.item_prop.layout.bg_color.value.hex:'#fff','color':field.item_prop.layout.header_font_color.hex}"
                  style="display:table-cell;word-break: break-word !important;min-width:25px"
                  class="text-right"
                >{{field.item_prop.label.amt.label}}</th>
              </thead>

              <tbody>
                <tr v-for="(item,index) in list.credit_details_items" :key="index">
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.qty.show"
                    class="text-left"
                    style="display:table-cell;padding-right:2px !important;padding-left:2px !important;word-break: break-word !important;vertical-align:top !important"
                  >{{ index + 1 }}</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.item.show||field.item_prop.label.desc.show"
                    class="text-left"
                    style="display:table-cell;padding-right:2px !important;padding-left:2px !important;vertical-align:top !important"
                  >
                    <span
                      v-if="field.item_prop.label.item.show"
                      style="word-break:break-word !important"
                    >{{item.pdt_name }}</span>
                    <span
                      v-if="field.item_prop.label.desc.show"
                      style="word-break:break-word !important;display:block;"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                    >{{item.pdt_desc }}</span>
                    <template
                      v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc"
                    >
                      <span
                        v-if="item.pdt_hsn"
                        :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                        style="font-weight:500!important;display:block;font-size:7pt;padding-right:2px !important;"
                      >HSN/SAC : {{ item.pdt_hsn }}</span>
                    </template>
                  </td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.hsn.show&&field.item_prop.label.hsn.show_in_desc==0"
                    class="text-left"
                    style="display:table-cell;word-break: break-word !important"
                  >{{ item.pdt_hsn }}</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.qty.show"
                    class="text-right"
                    style="display:table-cell;padding-right:2px !important;padding-left:2px !important;vertical-align:top !important"
                  >
                    {{ item.pdt_qty }}
                    <span
                      class="d-block"
                      :style="{'font-size':field.item_prop.layout.item_font_size +'pt !important','color':field.item_prop.layout.item_font_color.hex +' !important'}"
                      style="word-break: break-word !important;display:block"
                      v-if="field.item_prop.label.qty.show_unit"
                    >{{item.unit_name}}</span>
                  </td>

                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.rate.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word;padding-right:2px !important;padding-left:2px !important;vertical-align:top !important"
                  >{{ parseFloat(item.unit_price) }}</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    v-if="field.item_prop.label.discount.show"
                    class="text-right"
                    style="display:table-cell;word-break: break-word !important;vertical-align:top !important"
                  >{{ parseFloat(item.crdt_discount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <!-- <td
                    v-if="(field.item_prop.label.tax.show||field.item_prop.label.tax_amt.show) && org_details.gst_type == 1"
                    class="text-right"
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    style="display:table-cell;word-break: break-word !important"
                  >
                    <span
                      class="d-block"
                      v-if="field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show"
                    >{{parseFloat(item.crdt_tax_percent).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}</span>
                    <span
                      v-if="field.item_prop.label.tax.show"
                      :style="{'font-size':field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show?'6pt':''}"
                    >{{ item.tax_name != null ? item.tax_name+' ['+parseFloat(item.crdt_tax_percent)+' %]' : '0 %' }}</span>
                  </td>-->
                  <td
                    v-for="(tax_split,tax_index) in item.tax_type_details"
                    :key="tax_index"
                    v-if="(field.item_prop.label.tax.show||field.item_prop.label.tax_amt.show) && org_details.gst_type == 1"
                    class="text-right"
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    style="display:table-cell;word-break: break-word !important;vertical-align:top !important"
                  >
                    <span
                      style="display:block"
                      v-if="field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show"
                    >{{tax_split.tax_amount?parseFloat(tax_split.tax_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }):'-'}}</span>
                    <span
                      v-if="field.item_prop.label.tax.show"
                      :style="{'color':field.item_prop.layout.item_font_color.hex,'font-size':field.item_prop.label.hasOwnProperty('tax_amt')&&field.item_prop.label.tax_amt.show?'6pt':''}"
                    >{{ tax_split.value?item.tax_name != null ? parseFloat(tax_split.value)+'%' : '0%':'-' }}</span>
                  </td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    class="text-right"
                    style="display:table-cell;word-break: break-word;padding-right:2px !important;padding-left:2px !important;vertical-align:top !important"
                    v-if="field.item_prop.label.amt.show && list.header_details.tax_type_id == 1 && list.header_details.discount_cat == 1"
                  >{{ parseFloat(item.crdt_subtotal).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    class="text-right"
                    style="display:table-cell;word-break: break-word;padding-right:2px !important;padding-left:2px !important;vertical-align:top !important"
                    v-else-if="field.item_prop.label.amt.show && list.header_details.tax_type_id == 2 && list.header_details.discount_cat == 1"
                  >{{ parseFloat(item.subtotal_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                  <td
                    :style="{'font-size':field.item_prop.layout.item_row_font_size +'pt !important','background-color':field.item_prop.layout.item_row_bg_color.show == 1?field.item_prop.layout.item_row_bg_color.value.hex:'#fff','color':field.item_prop.layout.item_row_font_color.hex }"
                    class="text-right"
                    style="display:table-cell;word-break: break-word;padding-right:2px !important;padding-left:2px !important;vertical-align:top !important"
                    v-else-if="field.item_prop.label.amt.show"
                  >{{ parseFloat(item.crdt_price_with_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <template v-if="field.total_prop.label.show_total_sec">
            <!-- Invoice total and tax details -->
            <div
              class="invoice-total-tax"
              :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important','background-color':field.total_prop.layout.total_bg_color.show == 1?field.total_prop.layout.total_bg_color.value.hex:'#fff','color':field.total_prop.layout.total_font_color.hex }"
            >
              <div v-if="field.total_prop.label.show_total_qty" style="display:flow-root;">
                <p
                  class="float-left"
                  style="width:50%;word-break:break-word !important"
                >{{field.total_prop.label.item_in_total}}</p>
                <p
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                >{{list.header_details.total_qty}}</p>
              </div>
              <div
                v-if="field.total_prop.label.sub_total.show&&field.total_prop.label.show_total_sec"
                style="display:flow-root;"
              >
                <h6
                  :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important'}"
                  class="float-left"
                  style="width:50%;word-break:break-word !important"
                >{{field.total_prop.label.sub_total.label+(list.header_details.tax_type_id == 1?'(Tax Inclusive)':'')}}</h6>

                <h6
                  :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important'}"
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                  v-if="list.header_details.tax_type_id == 1 && list.header_details.discount_cat == 1"
                >{{ parseFloat(parseFloat(list.header_details.total_credit_amount) - parseFloat(list.header_details.adjusted_amount)).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</h6>
                <h6
                  :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important'}"
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                  v-else-if="list.header_details.tax_type_id == 2 && list.header_details.discount_cat == 1"
                >{{ parseFloat(list.header_details.total_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</h6>
                <h6
                  :style="{'font-size':field.total_prop.layout.total_font_size +'pt !important'}"
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                  v-else-if="list.header_details.discount_cat != 1"
                >{{ parseFloat(list.header_details.total_price_with_qty).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</h6>
              </div>
              <div
                v-if="field.total_prop.label.show_total_sec&&field.total_prop.label.show_discount"
                style="display:flow-root;"
              >
                <p class="float-left" style="width:50%;word-break:break-word !important">Discount</p>
                <p
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                >
                  <span :class="{'float-right':field.total_prop.label.currency_syb==2}"></span>
                  {{'(-) ' + parseFloat(list.header_details.crdt_discount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
                </p>
              </div>
              <div
                v-if="field.total_prop.label.show_total_sec && list.header_details.discount_cat == 3 && list.header_details.is_tax_reverse_charge == 0"
                style="display:flow-root;"
              >
                <div style="display:flow-root;" v-for="taxlist in splitted_tax" :key="taxlist.id">
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important"
                  >{{ taxlist[0].label+' on '+taxlist[0].taxable }}</p>
                  <p
                    class="float-right text-right"
                    style="width:50%;word-break:break-word !important"
                  >{{ parseFloat(taxlist[0].value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                </div>
              </div>

              <div
                v-if="field.total_prop.show_total_sec && list.header_details.discount_cat == 3 && list.header_details.is_tax_reverse_charge == 0"
                style="display:flow-root;"
              >
                <div style="display:flow-root;" v-for="taxlist in splitted_tax" :key="taxlist.id">
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important"
                  >{{taxlist[0].label+' on '+taxlist[0].taxable}}</p>
                  <p
                    class="float-right text-right"
                    style="width:50%;word-break:break-word !important"
                  >{{ currency_symbol +" "+ parseFloat(taxlist[0].value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                </div>
              </div>

              <div
                v-if="field.total_prop.label.show_total_sec && list.header_details.discount_cat != 3 && list.header_details.is_tax_reverse_charge == 0"
                style="display:flow-root;"
              >
                <div
                  style="display:flow-root;"
                  v-for="taxlist in splitted_tax"
                  v-if="taxlist != null"
                  :key="taxlist.id"
                >
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important"
                  >{{ taxlist[0].label+' on '+taxlist[0].taxable }}</p>
                  <p
                    class="float-right text-right"
                    style="width:50%;word-break:break-word !important"
                  >{{ parseFloat(taxlist[0].value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                </div>
              </div>

              <div v-if="list.header_details.adjusted_amount != 0" style="display:flow-root;">
                <p
                  class="float-left"
                  style="width:50%;word-break:break-word !important"
                >{{ list.header_details.adjustment_name }}</p>
                <p
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                >{{ parseFloat(list.header_details.adjusted_amount ).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
              </div>
              <div
                v-if="field.total_prop.label.show_total_sec && field.total_prop.label.shipping_charge && list.header_details.shipping_amount != 0"
                style="display:flow-root;"
              >
                <p
                  class="float-left"
                  style="width:50%;word-break:break-word !important"
                >{{field.total_prop.label.shipping_charge}}</p>
                <p
                  class="float-right text-right"
                  style="width:50%;word-break:break-word !important"
                >{{list.header_details.shipping_amount}}</p>
              </div>

              <div v-if="field.total_prop.label.show_pay_detail" style="font-style:italic">
                <div
                  v-if="list.header_details.refund&&field.total_prop.label.refund "
                  style="display:flow-root;"
                >
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important"
                  >{{ field.total_prop.label.refund }}</p>
                  <p
                    class="float-right text-danger text-right"
                    style="width:50%;word-break:break-word !important"
                  >(-) {{ parseFloat(list.header_details.refund_amount ).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                </div>
                <div v-if="field.total_prop.label.credits_used" style="display:flow-root;">
                  <p
                    class="float-left"
                    style="width:50%;word-break:break-word !important"
                  >{{field.total_prop.label.credits_used}}</p>
                  <p
                    class="float-right text-danger text-right"
                    style="width:50%;word-break:break-word !important"
                  >(-) {{ parseFloat(list.header_details.used_amount ).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                </div>

                <!-- <div v-if="field.total_prop.label.credits_remaining" style="display:flow-root;">
                  <p class="float-left">{{field.total_prop.label.credits_remaining}}</p>
                  <p
                    class="float-right"
                  >{{ parseFloat(list.header_details.available_amount ).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                </div>-->
              </div>
            </div>

            <!-- Invoice grand total -->
            <div
              class="grand-total"
              v-if="field.total_prop.label.show_pay_detail"
              style="display:flow-root;background:#fff !important"
            >
              <h4
                class="float-left"
                style="width:50%;word-break:break-word !important"
              >{{field.total_prop.label.credits_remaining}}</h4>

              <h4 class="float-right text-right" style="width:50%;word-break:break-word !important">
                <span
                  :class="{'float-right':field.total_prop.label.currency_syb==2}"
                >{{currency_symbol}}</span>
                <!-- {{parseFloat(list.header_details.total_credit_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }} -->
                {{ parseFloat(list.header_details.available_amount ).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
              </h4>
            </div>
            <div class="grand-total" v-else style="display:flow-root;background:#fff !important">
              <h4
                class="float-left"
                style="width:50%;word-break:break-word !important"
              >{{field.total_prop.label.total}}</h4>

              <h4 class="float-right text-right" style="width:50%;word-break:break-word !important">
                <span
                  :class="{'float-right':field.total_prop.label.currency_syb==2}"
                >{{currency_symbol}}</span>
                {{parseFloat(list.header_details.total_credit_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
              </h4>
            </div>
          </template>
          <!-- Invoice notes -->
          <div v-if="true" :style="{'color':field.temp_prop.font_color.hex}">
            <p
              class="invoice-notes text-center"
              style="word-break:break-word !important"
            >{{ crdt_settings_details.cus_inv_notes }}</p>
          </div>
        </div>
        <!-- End of Body -->
        <!-- Footer block -->
        <div
          class="invoice-footer-block"
          :style="{'height':field.temp_prop.margin_bottom+'in'}"
          style="background:#fff"
        ></div>
      </div>
    </div>
    <!-- End -->
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { number_to_words } from "@/mixins/NumberToWords";
export default {
  props: ["list", "printlabel", "showprintlabel"],
  data() {
    return {
      total_in_words: "",
      imageSrc: "",
      tax_list: "",
      currency_symbol: "",
      splitted_tax: []
    };
  },
  created() {
    this.total_in_words =
      this.getDetails(
        this.$AppDetails.currency_details,
        this.list.header_details.cus_currency,
        "currency_code_number"
      ) +
      " " +
      number_to_words(
        this.list.header_details.total_credit_amount,
        this.getDetails(
          this.$AppDetails.currency_details,
          this.list.header_details.cus_currency,
          "currency_code_fraction"
        )
      );
    this.imageSrc =
      this.org_details.org_logo != null
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : this.imageSrc;
  },
  methods: {
    getIndexValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][0][prop] == val) {
          hasMatch = i;

          break;
        }
      }
      return hasMatch;
    }
  },
  mounted() {
    //    customer currency symbol
    this.currency_symbol = this.getDetails(
      this.$AppDetails.currency_details,
      this.list.header_details.cus_currency,
      "currency_symbol"
    );
    var splitted_tax_percent = [];
    var tax_on_taxable_amount = [];
    this.splitted_tax = [];
    this.list.credit_details_items.reduce((total, value) => {
      var tax_id =
        !isNaN(value.crdt_tax_id) && value.crdt_tax_id != ""
          ? parseFloat(value.crdt_tax_id)
          : 0;
      // <!-----------------------------------dynamic tax calculation based on tax group------------------------------------------>
      if (!isNaN(tax_id) && tax_id != 0) {
        var tax_ids = value.tax_ids ? value.tax_ids.split(",") : "";

        if (tax_ids != "" && tax_ids != null && typeof tax_ids != "undefined") {
          for (var i = 0; i < tax_ids.length; i++) {
            if (
              this.list.tax_list[value.crdt_itm_id][i].tax_amount != null &&
              typeof this.list.tax_list[value.crdt_itm_id][i].tax_amount !=
                "undefined" &&
              !isNaN(this.list.tax_list[value.crdt_itm_id][i].tax_amount)
            ) {
              splitted_tax_percent[tax_ids[i]] = !isNaN(
                splitted_tax_percent[tax_ids[i]]
              )
                ? parseFloat(splitted_tax_percent[tax_ids[i]]) +
                  parseFloat(
                    this.list.tax_list[value.crdt_itm_id][i].tax_amount
                  )
                : parseFloat(
                    this.list.tax_list[value.crdt_itm_id][i].tax_amount
                  );
              tax_on_taxable_amount[tax_ids[i]] = !isNaN(
                tax_on_taxable_amount[tax_ids[i]]
              )
                ? parseFloat(tax_on_taxable_amount[tax_ids[i]]) +
                  parseFloat(value.subtotal_without_tax)
                : parseFloat(value.subtotal_without_tax);
            }
            //  update splitted tax variable
            var hasMatch = this.getIndexValue(
              this.splitted_tax,
              "id",
              tax_ids[i],
              ""
            );
            var tax_details = [
              {
                id: tax_ids[i],
                label:
                  this.list.tax_main[tax_ids[i]].tax_name +
                  "[ " +
                  parseFloat(this.list.tax_list[value.crdt_itm_id][i].value) +
                  " %]",
                value: splitted_tax_percent[tax_ids[i]],
                taxable: parseFloat(tax_on_taxable_amount[tax_ids[i]]).toFixed(
                  2
                )
              }
            ];
            if (!isNaN(parseInt(hasMatch))) {
              this.splitted_tax[hasMatch] = tax_details;
            } else {
              this.splitted_tax.push(tax_details);
            }
          }
        }
      }
      return;
    }, 0);
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      field: state =>
        state.permission.print_settings_details["Credit Note"].template_list,
      credit_details: state => state.credit.details
    }),
    ...mapGetters(["org_details", "crdt_settings_details"])
  }
};
</script>




<style media="all" type="text/css">
.clearfix:after,
.clearfix:before {
  content: " ";
  display: table;
}
.ribbon {
  position: absolute !important;
  top: -4px;
  left: -5px;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.ribbon .ribbon-inner {
  font-size: 13px;
  text-align: center;
  color: #fff;
  top: 34px;
  left: -35px;
  width: 166px;
  padding: 4px;
  position: relative;
  transform: rotate(-45deg);
}
.ribbon .ribbon-inner:before {
  left: 0;
  border-left: 2px solid transparent;
}
.ribbon .ribbon-inner:after {
  right: -2px;
  border-bottom: 3px solid transparent;
}
.ribbon .ribbon-inner:after,
.ribbon .ribbon-inner:before {
  content: "";
  border-top: 5px solid transparent;
  border-left: 5px solid;
  border-left-color: inherit;
  border-right: 5px solid transparent;
  border-bottom: 5px solid;
  border-bottom-color: inherit;
  position: absolute;
  top: 20px;
  transform: rotate(-45deg);
}
@font-face {
  font-family: "WebFont-Ubuntu";
  src: local(Ubuntu),
    url(https://fonts.gstatic.com/s/ubuntu/v10/4iCs6KVjbNBYlgoKcg72nU6AF7xm.woff2);
}
.details-container {
  position: relative;
  margin-bottom: 35px;
  box-shadow: 0 0 6px #ccc;
}

.pcs-template {
  font-family: Ubuntu, "WebFont-Ubuntu";
  font-size: 9pt;
  color: #000000;
  background: #ffffff;
}

.pcs-header-content {
  font-size: 9pt;
  color: #000000;
  background-color: #ffffff;
}
.pcs-template-body {
  padding: 0 0.2in 0 0.1in;
}
.pcs-template-footer {
  height: 0.1in;
  font-size: 6pt;
  color: #000000;
  padding: 0 0.2in 0 0.1in;
  background-color: #ffffff;
}
.pcs-footer-content {
  word-wrap: break-word;
  color: #000000;
  border-top: 1px solid #e3e3e3;
}

.pcs-label {
  color: #000000;
}
.pcs-entity-title {
  font-size: 28pt;
  color: #000000;
}
.pcs-orgname {
  font-size: 10pt;
  color: #000000;
  margin-bottom: 5px;
}
.pcs-customer-name {
  font-size: 9pt;
  color: #000000;
}
.pcs-itemtable-header {
  font-size: 9pt;
  color: #000000;
  background-color: #ffffff;
}
.pcs-itemtable-breakword {
  word-wrap: break-word;
}
.pcs-taxtable-header {
  font-size: 9pt;
  color: #000;
  background-color: #f5f4f3;
}
.itemBody tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

.pcs-item-row {
  font-size: 8pt;
  border-bottom: 1px solid #e3e3e3;
  background-color: #ffffff;
  color: #000000;
}
.pcs-item-sku {
  margin-top: 2px;
  font-size: 10px;
  color: #444444;
}
.pcs-item-desc {
  color: #000000;
  font-size: 8pt;
}
.pcs-balance {
  background-color: #ffffff;
  font-size: 9pt;
  color: #000000;
}
.pcs-totals {
  font-size: 9pt;
  color: #000000;
  background-color: #ffffff;
}
.pcs-notes {
  font-size: 8pt;
}
.pcs-terms {
  font-size: 8pt;
}
.pcs-header-first {
  background-color: #ffffff;
  font-size: 9pt;
  color: #000000;
  height: auto;
}

.pcs-status {
  font-size: 15pt;
  border: 3px solid;
  padding: 3px 8px;
}
.billto-section {
  padding-top: 0mm;
  padding-left: 0mm;
}
.shipto-section {
  padding-top: 0mm;
  padding-left: 0mm;
}

@page :first {
  @top-center {
    content: element(header);
  }
  margin-top: 0.1in;
}

.pcs-template-header {
  padding: 0 0.2in 0 0.1in;
  height: 0.1in;
}

.pcs-template-fill-emptydiv {
  display: table-cell;
  content: " ";
  width: 100%;
}

/* Additional styles for RTL compat */

/* Helper Classes */

.inline {
  display: inline-block;
}
.v-top {
  vertical-align: top;
}
.text-align-right {
  text-align: right;
}
.rtl .text-align-right {
  text-align: left;
}
.text-align-left {
  text-align: left;
}
.rtl .text-align-left {
  text-align: right;
}

/* Helper Classes End */

.item-details-inline {
  display: inline-block;
  margin: 0 10px;
  vertical-align: top;
  max-width: 70%;
}

.total-in-words-container {
  width: 100%;
  margin-top: 10px;
}
.total-in-words-label {
  vertical-align: top;
  padding: 0 10px;
}
.total-in-words-value {
  width: 170px;
}
.total-section-label {
  padding: 5px 10px 5px 0;
  vertical-align: middle;
}
.total-section-value {
  width: 120px;
  vertical-align: middle;
  padding: 10px 10px 10px 5px;
}
.rtl .total-section-value {
  padding: 10px 5px 10px 10px;
}

.tax-summary-description {
  color: #727272;
  font-size: 8pt;
}
.itemBody td {
  padding: 0px !important;
  padding-left: 10px !important;
}
/* Overrides/Patches for RTL compat */
.rtl th {
  text-align: inherit; /* Specifically setting th as inherit for supporting RTL */
}
/* Overrides/Patches End */

.pcs-receipt-custom-header {
  height: 0.1in;
}
.pcs-receipt-custom-footer {
  height: 0.1in;
}
.pcs-receipt-header {
  text-align: center;
}
.pcs-item-row {
  border-bottom: none;
}
.pcs-itemtable-header {
  /* border-top: 1px dashed #3c3d3a; */
  border-bottom: 1px dashed #3c3d3a;
}
.pcs-balance td {
  border-top: 1px solid #3c3d3a;
  border-bottom: 1px solid #3c3d3a;
}
.pcs-receipt-header {
  padding: 0 0.2in 0 0.1in;
}
.rtl .pcs-receipt-header {
  padding: 0 0.1in 0 0.2in;
}
.pcs-receipt-body {
  padding: 0 0.2in 10px 0.1in;
}
.rtl .pcs-receipt-body {
  padding: 0 0.1in 10px 0.2in;
}
.pcs-receipt-body-fields {
  border-bottom: 1px dashed #3c3d3a;
  padding-top: 10px;
}
.pcs-receipt-body-field {
  /* width: 50%; */
  float: left;
  padding-bottom: 5px;
}
.rtl .pcs-receipt-body-field {
  float: right;
}
.itemBody tr:first-child td,
.pcs-totals tr:first-child td {
  padding-top: 5px !important;
}
.itemBody tr:last-child td,
.pcs-totals tr:last-child td {
  padding-bottom: 5px !important;
}
.pcs-balance {
  text-transform: uppercase;
  font-size: 14pt;
}
.pcs-itemheader-section {
  padding: 5px 0 5px 10px;
}
.rtl .pcs-itemheader-section {
  padding: 5px 10px 5px 0;
}
.pcs-lineitem-column {
  text-align: right;
  word-wrap: break-word;
}
.rtl .pcs-lineitem-column {
  text-align: left;
  word-wrap: break-word;
}
.pcs-itemvalue-section {
  padding-left: 10px !important;
}
.rtl .pcs-itemvalue-section {
  padding-right: 10px !important;
}
.details-container td {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.pr-0 {
  padding-right: 0px !important;
}
.pl-0 {
  padding-left: 0px !important;
}
.pcs-itemtable .pcs-itemtable-header {
  font-weight: 500 !important;
}
/* THERMAL PRINT CUSTOMIZE CSS */
/* // Bootstrap class */
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
.thermal-custom-invoice-address p,
.thermal-invoice-details {
  margin-bottom: 1px !important;
  font-size: 9pt;
}
.thermal-custom-invoice-address,
.thermal-invoice-details {
  border-bottom: 1px dashed #000;
  margin-bottom: 5px;
}
.invoice-item-table {
  border-top: 1px dashed #000;
}
.invoice-item-table table {
  width: 100% important;
  font-size: 9pt;
}
.invoice-item-table table td,
.invoice-item-table table th {
  padding: 5px !important;
  font-size: 8.5pt !important;
}
.invoice-item-table table > thead > th {
  border-bottom: 1px dashed #000;

  padding-bottom: 5px;
}

.invoice-item-table table tr:last-child > td {
  border-bottom: 1px dashed #000;
}
.invoice-total-tax {
  margin-top: 5px;
  border-bottom: 1px solid #000;
}
.invoice-total-tax p {
  margin-bottom: 5px;
  /* font-size: 9pt; */
}
.grand-total {
  border-bottom: 1px solid #000;
}
.grand-total h4 {
  margin-top: 5px;
}
p.invoice-notes {
  font-size: 8pt !important;
  margin-top: 10px;
  margin-bottom: 0px;
}
#inch3-thermal-print-page {
  width: 3in;
  min-height: fit-content;
}
#inch4-thermal-print-page {
  width: 4in;
  min-height: fit-content;
}
#inch4-thermal-print-page .inch3-details-view,
#inch3-thermal-print-page .inch4-details-view {
  display: none;
}
</style>
